// @flow

import { startRequest, finishRequest } from "@store/utils";
import type { ReferralTrackerState } from "./types";

export const setLoading = (state: ReferralTrackerState) => () => startRequest(state);

export const onGetSupplierClosedReferralsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    closedReferrals: payload,
  };
};

export const onGetSupplierClosedReferralsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

// RTW Toggle
export const onToggleRTWReferralDetailsModal = (state: ReferralTrackerState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showRTWReferralDetails: !state.modals.showRTWReferralDetails,
    },
  };
};
// RTW Success
export const onGetRTWReferralDetailsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    referralRTWDetails: payload,
  };
};
// RTW Error
export const onGetRTWReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

// Log Toggle
export const onToggleLogReferralDetailsModal = (state: ReferralTrackerState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showLogReferralDetails: !state.modals.showLogReferralDetails,
    },
  };
};
// Log Success
export const onGetLogReferralDetailsSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    referralLogDetails: payload,
  };
};

export const onSubmitLogReferralDataSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  let referralLogDetails = [...state.referralLogDetails];
  referralLogDetails.push(payload);
  return {
    ...finishRequest(state),
    error: null,
    referralLogDetails,
  };
};

export const onSetReferralCommonData = (state: ReferralTrackerState) => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    commonData: { ...state.commonData, ...payload },
  };
};

// Log Error
export const onGetLogReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

// Status Toggle
export const onToggleStatusReferralDetailsModal = (state: ReferralTrackerState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      showStatusReferralDetails: !state.modals.showStatusReferralDetails,
    },
  };
};
// Status Error
export const onGetStatusReferralDetailsError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});

export const onGetSupplierClosedReferralsStatusesSuccess = (state: ReferralTrackerState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    closedReferralsStatuses: payload,
  };
};

export const onGetSupplierClosedReferralsStatusesError = (state: ReferralTrackerState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
});
